module.exports = __webpack_public_path__ + "img/info_Card1.739d2818.png";